module.exports = __webpack_public_path__ + "img/channels4_profile-removebg-preview.3cbfabd8.png";